import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp';
import type { IPOSMaterialCode } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<IPOSMaterialCode>[] => [
  {
    field: 'ma_vt_data',
    headerName: 'Mã vật tư',
    width: 120,
    renderCell: (params: DataTableRenderCellParams<IPOSMaterialCode>) => params.row.ma_vt_data?.ma_vt || ''
  },
  {
    field: 'ma_khai_bao',
    headerName: 'Mã hàng hóa',
    width: 200
  },
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 170,
    renderCell: (params: DataTableRenderCellParams<IPOSMaterialCode>) =>
      params.row.status === '1' ? ' Còn sử dụng' : 'Không sử dụng'
  }
];
